<template>
    <CheckboxRoot
        v-bind="forwarded"
        :class="
            cn(
                'peer size-5 shrink-0 rounded-xs border border-gray-900 ring-offset-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gray-900 data-[state=checked]:text-gray-50',
                props.class
            )
        ">
        <CheckboxIndicator class="flex h-full w-full items-center justify-center text-current">
            <slot>
                <Icon name="check" />
            </slot>
        </CheckboxIndicator>
    </CheckboxRoot>
</template>
<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import type { CheckboxRootEmits, CheckboxRootProps } from "reka-ui";
import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps<CheckboxRootProps & { class?: HTMLAttributes["class"] }>();
const emits = defineEmits<CheckboxRootEmits>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
